<div class="wrapper">
  <app-icca-server-file-select-table [files]="files$ | async" [loadInProgress]="loadInProgress"
    (rowsChanged)="rowsChanged($event)">
  </app-icca-server-file-select-table>
</div>